import { CancelOutlined, Done } from "@mui/icons-material";
import { Alert, AlertTitle } from "@mui/material";
import React from "react";

/** @typedef {import("@mui/material").AlertProps} AlertProps */

/**
 * Master portal wrapper for MUI Alert
 * 
 * @param {Object} props 
 * @param {AlertProps["variant"]} [props.variant = "standard"]
 * @param {AlertProps["severity"]} [props.severity = "info"]
 * 
 * @param {AlertProps["icon"]} [props.icon]
 * @param {AlertProps["onClose"]} [props.onClose]
 * @param {AlertProps["action"]} [props.action]
 * @param {string} [props.title]
 * @param {React.ReactNode} [props.children]
 * @returns 
 */
const Notice = ({
  variant = "standard",
  severity = "info",
  icon,
  onClose,
  action,
  title,
  children
}) => {
  return <Alert
    variant={variant}
    severity={severity}
    icon={icon}
    iconMapping={{
      // Somehow this prop aren't working in mui theme with defaultProps, so it is placed here
      success: <Done />,
      error: <CancelOutlined />
    }}
    onClose={onClose}
    action={action}
  >
    {title && <AlertTitle>{title}</AlertTitle>}
    {children}
  </Alert>
};

export default React.memo(Notice);
